import { render, staticRenderFns } from "./markdown-it-vue-light.vue?vue&type=template&id=66b5a568&"
import script from "./markdown-it-vue-light.vue?vue&type=script&lang=js&"
export * from "./markdown-it-vue-light.vue?vue&type=script&lang=js&"
import style0 from "./markdown-it-vue-light.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports